module.exports = __webpack_public_path__ + "img/works_kuraray_miniapp_6.06d56da8.jpg";